import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useParams } from 'react-router';

import { useChannelById } from '@/api/channel';
import Error404 from '@/components/errors/Error404';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { ReturnToLink } from '@/components/ReturnToLink';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';
import { ROUTES } from '@/router';

import ChannelDetailActions from './ChannelDetailActions';
import ChannelDetailKPIMetrics from './ChannelDetailKPIMetrics';
import ChannelVisitsOverviewTable from './ChannelVisitsOverviewTable';
import ChannelWeeklyVisitsChart from './ChannelWeeklyVisitsChart';

const ChannelDetail = () => {
  const { channel: channelId } = useParams();
  const { channel, isLoading } = useChannelById(channelId);

  return (
    <Page
      title={t`Channels`}
      pageName={channel?.name}
      exampleAIQuestions={exampleAIQuestions('channel')}
    >
      <div className="flex w-full flex-col gap-6">
        <ReturnToLink route={ROUTES.channels.path} routeName={<Trans>Channels</Trans>} />
        {!isLoading && channel == null ? (
          <Error404 title={<Trans>The channel you're looking for does not exist</Trans>} />
        ) : (
          <>
            <PageFilterProvider>
              <div className="flex justify-between">
                <PageDateRangeFilter />
                <ChannelDetailActions channelId={channelId!} isLoading={isLoading} />
              </div>
              <ChannelDetailKPIMetrics channelId={channel?.id} />
              <ChannelWeeklyVisitsChart channelId={channel?.id} />
              <ChannelVisitsOverviewTable channelId={channel?.id} />
            </PageFilterProvider>
          </>
        )}
      </div>
    </Page>
  );
};

export default ChannelDetail;
